import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Quote from "components/Typography/Quote.jsx";
// core components

import SectionDestacadas from "KComponents/SectionDestacadas.jsx";
import SectionRecents from "KComponents/SectionRecents.jsx";

import sectionTextStyle from "assets/jss/material-kit-pro-react/views/blogPostSections/sectionTextStyle.jsx";

function SectionText({ ...props }) {
  const { classes } = props;
  const { featured } = props;
  const { recents } = props;
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>
            In every scenario, we focus on client communication and timely delivery.
          </h3>
          <p>
            At the core of our service is a national, joined up approach to industrial and logistics agency, consisting of experts based out of Madrid and key regional markets, giving us wide coverage to help clients in all areas.
Our success and strength stems from our ability to provide an integrated service combining specialists offering expertise in a range of associated service lines. These cover all elements of the sector, including corporate real estate, funding, building consultancy, project management, lease consultancy, investment, valuation, planning and development. Having this connected Spain network of experts ( Torus Network ) allows the constant monitoring and tracking of activity across local, regional and national markets.
Our Partners assists and advises some of the largest and most active players in the industrial and logistics sector, including funds/investors, developers, and occupiers.
          </p>
          <Quote
            textClassName={classes.quoteText}
            text="“Excellence is our Goal, customers satisfaction our proud!”"
            author="Joaquín Morales, CEO."
          />
        </GridItem>
        <GridItem xs={12} sm={10} md={10} className={classes.section}>
          <SectionDestacadas featured={recents} url="industrial" />
          <SectionRecents recents={recents} url="industrial" />
        </GridItem>
        <GridItem xs={12} sm={8} md={8} id="search" >
        </GridItem>
      </GridContainer>
    </div>
  );
}

export default withStyles(sectionTextStyle)(SectionText);
